import { render, staticRenderFns } from "./ProgettoEdit.vue?vue&type=template&id=04eb80ac&scoped=true"
import script from "./ProgettoEdit.vue?vue&type=script&lang=js"
export * from "./ProgettoEdit.vue?vue&type=script&lang=js"
import style0 from "./ProgettoEdit.vue?vue&type=style&index=0&id=04eb80ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb80ac",
  null
  
)

export default component.exports